import React from 'react';
import { Flex, IconButton, Text, Button } from '@chakra-ui/react';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { useHistory } from 'react-router-dom';
import Container from 'components/PageContainer';

type WithHeaderProps = {
  title: string;
  previousPage: string;
  children: React.ReactNode;
  margin?: boolean;
  headerAction?: () => void;
  headerActionText?: string;
  headerActionEnabled?: boolean;
  headerActionSubmitting?: boolean;
  containerBg?: string;
};
const WithHeader = ({
  title,
  previousPage,
  children,
  headerAction,
  headerActionText,
  headerActionEnabled,
  headerActionSubmitting,
  containerBg = 'custom.levoOffWhite',
}: WithHeaderProps): JSX.Element => {
  const history = useHistory();
  const goToPage = () => {
    history.push(previousPage);
  };
  return (
    <Container>
      <Flex
        position="sticky"
        top="0"
        direction="row"
        justifyContent="center"
        alignItems="center"
        width="100%"
        pt={16}
        pb={6}
        bg="custom.levoOffWhite"
        zIndex={100}
      >
        <IconButton
          position="absolute"
          left="10px"
          size="sm"
          bg="transparent"
          aria-label="Go to previous page"
          icon={<ChevronLeftIcon boxSize={8} />}
          onClick={goToPage}
        />
        <Text textStyle="heading3" fontWeight="bold" textAlign="center">
          {title}
        </Text>
        {headerAction && headerActionText && (
          <Button
            position="absolute"
            right="5px"
            variant="ghost"
            color={
              headerActionEnabled ? 'custom.levoBlue' : 'custom.levoLightBlack'
            }
            cursor={headerActionEnabled ? 'pointer' : 'default'}
            disabled={!headerActionEnabled || headerActionSubmitting}
            isLoading={headerActionSubmitting}
            onClick={headerAction}
          >
            <Text textStyle="heading3" fontWeight="bold" letterSpacing="-0.41%">
              {headerActionText}
            </Text>
          </Button>
        )}
      </Flex>
      <Flex direction="column" flexGrow={1} bg={containerBg} pt={4}>
        {children}
      </Flex>
    </Container>
  );
};

export default WithHeader;
